import {debug} from "util";


import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {DimensionStyleSet} from "InternalShared/PageBuilder/Controls/Properties/StyleSets/DimensionStyleSet";
import {GroupProperties} from "InternalShared/PageBuilder/Controls/Properties/styles/GroupProperties";
import {AllowedResizeDirection} from "InternalShared/Dto";
import {TextProperty} from "InternalShared/PageBuilder/Controls/Properties/TextProperty";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";

import {HtmlProperty} from "InternalShared/PageBuilder/Controls/Properties/HtmlProperty";
import {HtmlControlOptions} from "./HtmlControl.Options";




declare let rednaoPDFInvoiceParams:any;
export class HtmlControl extends PDFControlBase{


    GetStyles(): GroupProperties[] {

            return [
                DimensionStyleSet.GetStyles(this)

            ];
    }
    public AllowedResizeDirection: AllowedResizeDirection = "both";
    public Options:HtmlControlOptions;
    private properties:GroupProperties[];



    public InternalInitialize() {
        this.StyleManager.AddStyleSet('p', {'padding': '0','margin':0});
    }


    public NeedTranslations(): boolean {
        return true;
    }



    protected InternalGenerateHtml($container: JQuery) {
        $container.css('text-align','left');
        $container.append(this.Options.HTML);
    }

    public GetProperties(): GroupProperties[] {
        if(this.properties==null)
        {
            this.properties=[new GroupProperties('General')
                .AddProperties([
                    new HtmlProperty(this,'HTML').Focus().SetLabel("HTML")
                ])];
        }

        return this.properties;
    }


    public AfterRefresh() {
        let height:number=this.$element.find('.elementContent').height();
        this.$element.velocity('stop',true);
        this.$element.velocity(200,"easeInExp");

    }

    GetInitialOptions(): Promise<PDFControlBaseOptions> {
        return new Promise(resolve => {
            resolve(new HtmlControlOptions().Merge());
        });
    }
}
